// This must be the first line in src/index.js
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'
import ReactModal from 'react-modal'
import * as Sentry from '@sentry/react'
import { Integrations as TracingIntegrations } from '@sentry/tracing'
import TagManager from 'react-gtm-module'
import mixpanel from 'mixpanel-browser'
import 'react-crane/dist/crane.min.css'
import './index.css'
import * as serviceWorker from './serviceWorker'
import history from './lib/history'
import { EnvironmentContext } from './lib/hooks/useEnvironment'
import { getEnvironment } from './lib/environment'
import Root from './Root'

const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID
const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE
const sentryDsn = process.env.REACT_APP_SENTRY_DSN
const buildEnv = process.env.REACT_APP_BUILD_ENVIRONMENT
const mixpanelToken = process.env.REACT_APP_MIXPANEL_TOKEN

const tagManagerArgs = {
  gtmId: 'GTM-ND7Z5PT',
  dataLayer: {
    institution: getEnvironment()
  }
}
TagManager.initialize(tagManagerArgs)

mixpanel.init(mixpanelToken || '')

Sentry.init({
  dsn: sentryDsn,
  // This enables automatic instrumentation
  environment: buildEnv,
  integrations: [
    new TracingIntegrations.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
    })
  ],
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#enabled
  enabled: false,
  // error sample rate
  sampleRate: 1.0,
  // To set a uniform sample rate
  tracesSampleRate: 0.2
})

if (!auth0Domain || !auth0ClientId || !auth0Audience) {
  throw new Error('missing env vars')
}

ReactDOM.render(
  <EnvironmentContext.Provider value={getEnvironment()}>
    <Router history={history}>
      <Root />
    </Router>
  </EnvironmentContext.Provider>,
  document.getElementById('root')
)

/**
 * Necessary implementation for screen-readers. Read more:
 * ttp://reactcommunity.org/react-modal/accessibility/#app-element
 */
ReactModal.setAppElement(`#root`)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
